import { render } from "./TagBubbleInput.vue?vue&type=template&id=74650f84&scoped=true"
import script from "./TagBubbleInput.vue?vue&type=script&lang=js"
export * from "./TagBubbleInput.vue?vue&type=script&lang=js"

import "./TagBubbleInput.vue?vue&type=style&index=0&id=74650f84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74650f84"]])

export default __exports__